import AES from 'crypto-js/aes';
import store from '@/store/store'

export default {
    encrypt(token){
        let key = process.env.MIX_APP_SECRET
        let encrypt = AES.encrypt(token, key).toString();

        return encrypt
    },
    decrypt(encrypted){
        // Outputs the decrypted text in Hex
        let key = process.env.MIX_APP_SECRET
        let decrypted_hex = AES.decrypt(encrypted, key);
        // Converts the decrypted Hex output to utf8 readable text
        let decrypted_text = Buffer.from(decrypted_hex.toString(), 'hex').toString('utf8');

        return decrypted_text
    }
}
